<template>
  <v-dialog v-model="reprocessingDialog" max-width="1000" persistent>
    <v-form ref="reprocessing_form">
      <v-card>
        <v-card-title class="headline">{{
          isPartnerManagement ? "Editar Fatura" : "Reprocessamento de Fatura"
        }}</v-card-title>

        <v-card-text>
          Insira os dados para recalcular o valor da fatura
          <v-container>
            <v-flex sm12>
              <v-text-field
                label="Energia Injetada (kWh)"
                v-model.number="amount_kW"
                :rules="[
                  (v) =>
                    !!v ||
                    'Por favor informe a quantidade de energia injetada.',
                ]"
                required
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Valor do kWh (R$)"
                v-model.number="energy_kWh_value"
                :rules="[(v) => !!v || 'Por favor informe o valor do kWh.']"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Valor do kWh (Sem imposto) (R$)"
                v-model.number="amount_comp_kWh_value"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field label="Consumo (kWh)" v-model.number="energy_kWh" />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Custo de Disponibilidade (R$)"
                v-model.number="custo_disp"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Impostos PIS/COFINS (R$)"
                v-model.number="tax"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Bonus (R$)"
                v-model.number="account_balance"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field label="Consumo (kWh)" v-model.number="energy_kWh" />
            </v-flex>

            <v-flex sm12>
              <v-text-field label="Saldo (kWh)" v-model.number="balance" />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Demais Encargos (R$)"
                v-model.number="other_charges"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Valor da Concessionária"
                v-model.number="total_invoice"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Juros e Multas (R$)"
                v-model.number="juros_multas"
              />
            </v-flex>

            <v-flex sm12 v-if="!isPartnerManagement">
              <v-text-field
                label="Correção de Pagamento Duplicado (R$)"
                v-model.number="duplicated_payment_total"
              />
            </v-flex>

            <v-flex sm12 v-if="!isPartnerManagement">
              <v-text-field
                label="Identificação de Parcela de Correção de Pagamento Duplicado (X/X)"
                v-model="duplicated_payment_desc"
              />
            </v-flex>

            <v-flex sm12>
              <v-text-field
                label="Valor Total da Fatura (R$)"
                v-model.number="total"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 md3>
              <v-select
                label="Método de Pagamento"
                v-model="payment_type"
                :items="payment_type_items"
                item-value="value"
                item-text="text"
                :rules="[
                  (v) => !!v || 'Por favor, informe o método de pagamento',
                ]"
                required
              />
            </v-flex>

            <v-flex sm12>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="due_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                dark
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="due_date"
                    label="Nova Data de Vencimento"
                    prepend-icon="event"
                    :rules="[
                      (v) =>
                        !!v || 'Por favor informe a nova data de vencimento.',
                    ]"
                    readonly
                  />
                </template>
                <v-date-picker
                  v-model="due_date"
                  no-title
                  scrollable
                  :min="new Date().toISOString()"
                  :max="maxDate()"
                >
                  <v-spacer />
                  <v-btn flat color="primary" @click="menu = false"
                    >Cancelar</v-btn
                  >
                  <v-btn flat color="primary" @click="$refs.menu.save(due_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-switch
              v-if="!isPartnerManagement"
              v-model="checkbox_unique_billing"
              label="Cobrar Conta da Concessionária"
            />
            <v-switch
              v-model="checkbox_custo_disp"
              label="Cobrar Custo de Disponibilidade"
            />
            <v-switch
              v-model="checkbox_calc_tax"
              label="Calcular Impostos (CPFL)"
            />
            <v-switch
              v-model="checkbox_tax"
              label="Cobrar Impostos PIS/COFINS"
            />
            <v-switch
              v-model="checkbox_calculateFees"
              label="Calcular automaticamente Juros e Multas"
            />

            <v-flex sm12>
              <v-textarea
                v-model="charges_description"
                label="Descrição das Cobranças"
              />
            </v-flex>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="red darken-1"
            flat="flat"
            @click="setReprocessingDialog(false)"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="!permissions.reprocess_billing"
            @click="reprocessing(billing.id, false)"
          >
            Recalcular
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            :disabled="!permissions.reprocess_billing"
            @click="reprocessing(billing.id, true)"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import firestore from "../../firebase/firestore";
import { getPermission } from "../../services/permissions";

export default {
  props: {
    billing: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    amount_kW: 0,
    discount: 0,
    energy_kWh_value: 0,
    custo_disp: 0,
    tax: 0,
    payment_type_items: [
      { text: "Cartão de Crédito", value: "credit_card" },
      { text: "Boleto", value: "boleto" },
      { text: "Pix", value: "pix" },
    ],
    payment_type: "",
    total: 0,
    account_balance: 0,
    total_invoice: null,
    charges_description: null,
    checkbox_unique_billing: false,
    checkbox_custo_disp: false,
    checkbox_tax: false,
    checkbox_calc_tax: false,
    checkbox_calculateFees: false,
    menu: false,
    due_date: new Date().toISOString().substring(0, 10),
    duplicated_payment_total: 0,
    duplicated_payment_desc: "",
    juros_multas: "",
    snackMessage: "",
    snackbar: false,
    color: "",
    balance: 0,
    energy_kWh: 0,
    amount_comp_kWh_value: 0,
    other_charges: 0,
  }),

  async mounted() {
    if (this.billing) {
      const userRef = await firestore
        .collection("users")
        .doc(this.billing.customer_id)
        .get();
      this.user = userRef.data();
      if (this.billing && this.billing.payment_type)
        this.payment_type = this.billing.payment_type;
      else if (this.billing && this.billing.transaction)
        this.payment_type = this.billing.transaction.payment_method;
      else if (this.user) this.payment_type = this.user.payment_type;
      this.amount_kW = this.billing.amount_kW;
      this.energy_kWh_value = this.billing.energy_kWh_value;
      this.custo_disp = this.billing.custo_disp || 0;
      this.tax = this.billing.tax || 0;
      this.discount = this.billing.discount;
      this.account_balance = this.billing.account_balance || 0;
      this.total_invoice = this.billing.total_invoice || 0;
      this.due_date = this.billing.due_date || this.due_date;
      this.total = this.billing.total;
      this.balance = this.billing.balance;
      this.energy_kWh = this.billing.energy_kWh;
      this.amount_comp_kWh_value = this.billing.amount_comp_kWh_value;
    }
  },

  computed: {
    ...mapState("billing", ["billingItems", "reprocessingDialog"]),
    ...mapState(["user", "permissions"]),

    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("partner_management") >= 0;
    },
  },

  methods: {
    ...mapMutations("billing", ["setReprocessingDialog", "spliceBillingItems"]),

    castNumber(value) {
      if (typeof value == "string") return Number(value.replace(",", "."));
      return value;
    },

    formatUtility(value) {
      if (value === "cemig" || !value) {
        return "Cemig";
      } else if (value === "cpfl-piratininga") {
        return "CPFL";
      } else if (value === "neoenergia-pe") {
        return "Neoenergia";
      }
      return value;
    },

    async reprocessing(id, save) {
      try {
        const permission = await getPermission(
          "reprocess_billing",
          this.user.id,
        );

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      const utilityCompanyName = this.formatUtility(
        this.billing.utility_company,
      );

      const old_values = {
        due_date: this.billing.due_date || null,
        amount_kW: this.billing.amount_kW,
        discount: this.billing.discount,
        energy_kWh_value: this.billing.energy_kWh_value,
        total: this.billing.total,
        payment_type: this.billing.payment_type || this.user.payment_type,
        account_balance: this.billing.account_balance || null,
        total_invoice: this.billing.total_invoice || null,
        invoice_url: this.billing.invoice_url || null,
        balance: this.billing.balance,
        energy_kWh: this.billing.energy_kWh,
        amount_comp_kWh_value: this.billing.amount_comp_kWh_value,
      };

      const changes = this.billing.changes || [];
      changes.push({
        user_id: this.user.id,
        user_email: this.user.email,
        updated_at: new Date(),
        old_values: old_values,
      });

      const newBilling = {
        updated_at: new Date(),
        due_date: this.due_date,
        force_due_date: true,
        split: null,
        amount_kW: this.castNumber(this.amount_kW),
        energy_kWh_value: this.castNumber(this.energy_kWh_value),
        account_balance: this.castNumber(this.account_balance),
        total_invoice: this.castNumber(this.total_invoice),
        payment_type: this.payment_type,
        invoice_url: null,
        changes: changes,
        transaction: null,
        tax: this.castNumber(this.tax),
        custo_disp: this.castNumber(this.custo_disp),
        balance: this.castNumber(this.balance),
        energy_kWh: this.castNumber(this.energy_kWh),
        other_charges: this.castNumber(this.other_charges),
        amount_comp_kWh_value: this.castNumber(this.amount_comp_kWh_value),
      };

      // Calcular total_utility_company
      const custo_disp_calc = Math.min(
        Math.max(this.billing.energy_kWh - this.billing.classe, 0) -
          newBilling.amount_kW,
        0,
      );
      const custo_disp_calc_value =
        Math.abs(custo_disp_calc) * newBilling.energy_kWh_value;
      const energy_amount = newBilling.amount_kW * newBilling.energy_kWh_value;
      newBilling.total_utility_company =
        this.billing.total_invoice +
        energy_amount -
        custo_disp_calc_value -
        newBilling.tax;

      //Cálculo do desconto
      let charges = [];
      let total;
      newBilling.tarifa =
        this.castNumber(this.amount_kW) *
        this.castNumber(this.energy_kWh_value);
      charges.push({ ref: "Energia Injetada", value: newBilling.tarifa });
      if (this.billing.fixed_rate) {
        newBilling.custom_discount =
          newBilling.tarifa -
          this.billing.fixed_rate * this.castNumber(this.amount_kW);
        total = this.billing.fixed_rate * this.castNumber(this.amount_kW);
        charges.push({
          ref: "Desconto Energia Limpa",
          value: newBilling.custom_discount * -1,
        });
      } else {
        const discount_percentage = this.billing.percentage_discount
          ? this.billing.percentage_discount / 100
          : null;
        if (!discount_percentage) {
          this.snack("Valor do desconto não encontrado", "error");
          return;
        }
        let discount_value = discount_percentage * newBilling.tarifa;
        total = (1 - discount_percentage) * newBilling.tarifa;
        charges.push({
          ref: "Desconto Energia Limpa",
          value: discount_value * -1,
        });
      }

      //Custo de disponibilidade
      if (!this.checkbox_custo_disp && this.castNumber(this.custo_disp) > 0) {
        total -= newBilling.custo_disp;
        charges.push({
          ref: `Desconto do Custo de Disponibilidade já cobrado pela ${utilityCompanyName}`,
          value: newBilling.custo_disp * -1,
        });
      }

      //Insere Juros e Multas
      if (
        this.juros_multas &&
        this.castNumber(this.juros_multas) > 0 &&
        !this.checkbox_calculateFees
      ) {
        total += this.castNumber(this.juros_multas);
        charges.push({
          ref: `Juros e multa por atraso de faturas anteriores`,
          value: this.castNumber(this.juros_multas),
        });
      }

      //Insere cobrança de faturas postponed
      if (this.billing.charged_postponed_billings && this.billing.charges) {
        this.billing.charges.forEach((charge) => {
          if (charge.ref.startsWith("Cobrança da fatura de")) {
            total += this.castNumber(charge.value);
            charges.push(charge);
          }
        });
      }

      //Calcula Juros automaticamente
      if (this.checkbox_calculateFees) {
        const billing_date =
          this.billing.due_date ||
          moment(this.billing.created_at.toDate()).format("YYYY-MM-DD");
        const delta = Math.abs(
          moment(billing_date).diff(moment(this.due_date), "days"),
        );
        const interest = total * Math.pow(1 + 0.01, delta / 30) - total;
        const fine = total * 0.02;
        const fees = interest + fine;
        total += fees;
        this.juros_multas = fees.toFixed(2);
        charges.push({
          ref: `Juros e multa por atraso de faturas anteriores`,
          value: fees,
        });
      }

      //Calcular impostos CPFL
      if (this.checkbox_calc_tax) {
        this.tax =
          newBilling.amount_kW * newBilling.energy_kWh_value -
          newBilling.amount_kW * newBilling.amount_comp_kWh_value;
        newBilling.tax = this.tax;
        console.log("imposto calc: ", newBilling.tax);
      }

      //Impostos
      if (!this.checkbox_tax && newBilling.tax > 0) {
        total -= newBilling.tax;
        charges.push({
          ref: `Desconto de Impostos já cobrados pela ${utilityCompanyName}`,
          value: newBilling.tax * -1,
        });
      }

      //Bônus
      if (newBilling.account_balance && newBilling.account_balance > 0) {
        total -= newBilling.account_balance;
        charges.push({ ref: "Bônus", value: newBilling.account_balance * -1 });
      }

      //Correção de pagamento duplicado
      let duplicated_payment_desc_error = false;
      if (this.castNumber(this.duplicated_payment_total) > 0) {
        let splitted_desc = this.duplicated_payment_desc.split("/");
        if (splitted_desc.length == 2) {
          if (isNaN(Number(splitted_desc[0])))
            duplicated_payment_desc_error = true;
          if (isNaN(Number(splitted_desc[1])))
            duplicated_payment_desc_error = true;
        } else duplicated_payment_desc_error = true;
        if (!duplicated_payment_desc_error) {
          newBilling.duplicated_payment_total = this.castNumber(
            this.duplicated_payment_total,
          );
          newBilling.duplicated_payment_desc = this.duplicated_payment_desc;
          total += newBilling.duplicated_payment_total;
          charges.push({
            ref: "Correção de pagamento duplicado",
            value: newBilling.duplicated_payment_total,
          });
        } else {
          this.snack(
            "A identificação de parcela da correção de pagamento duplicado deve ser no formato X/X",
            "error",
          );
          return;
        }
      } else {
        newBilling.duplicated_payment_total = null;
        newBilling.duplicated_payment_desc = null;
      }

      //Concessionária
      if (
        this.checkbox_unique_billing &&
        newBilling.total_invoice &&
        newBilling.total_invoice > 0
      ) {
        newBilling.unique_billing = true;
        newBilling.cemig_value_included = true;
        total += newBilling.total_invoice;
        charges.push({
          ref: `Fatura da ${utilityCompanyName}`,
          value: newBilling.total_invoice,
        });
      }
      if (!this.checkbox_unique_billing) newBilling.unique_billing = false;

      //Não permite fatura única no cartão
      if (
        save &&
        newBilling.unique_billing &&
        this.payment_type == "credit_card"
      ) {
        this.snack(
          "Não é possível cobrar o valor da concessionária em uma fatura paga por cartão de crédito",
          "error",
        );
        return;
      }

      //Não permite fatura única de conta retida
      if (newBilling.unique_billing && this.billing.bill_status == "withheld") {
        this.snack(
          "Não é possível cobrar o valor da concessionária, pois a conta está retida.",
          "error",
        );
        return;
      }

      //Extrato
      this.charges_description = "";
      charges.forEach((c) => {
        this.charges_description += `${c.ref}: R$ ${c.value
          .toFixed(2)
          .replace(".", ",")}\n`;
      });

      if (total < 0) total = 0;
      this.charges_description += `\nTotal da Fatura: R$ ${total
        .toFixed(2)
        .replace(".", ",")}`;
      newBilling.total = total;
      newBilling.charges = charges;
      this.total = total;

      // Calcular a economia do cliente
      if (!newBilling.unique_billing) {
        let totalPag = newBilling.total + this.billing.total_invoice;
        newBilling.discount = newBilling.total_utility_company - totalPag;
      } else
        newBilling.discount =
          newBilling.total_utility_company - newBilling.total;

      if (this.isPartnerManagement) {
        if (save) {
          await firestore.collection("billing").doc(id).update({
            regenerate_invoice: false,
          });
        }
        newBilling.regenerate_invoice = true;
      } else newBilling.status = "reprocessing";

      if (
        !this.checkbox_calculateFees &&
        (this.juros_multas === "" || this.juros_multas == "0")
      )
        newBilling.interest = null;

      //Salva fatura
      if (save) {
        await firestore
          .collection("billing")
          .doc(id)
          .update(newBilling)
          .then(async () => {
            if (this.isPartnerManagement) {
              // eslint-disable-next-line no-undef
              Toast.fire({
                icon: "success",
                title:
                  "Demonstrativo está sendo regerado. Aguarde alguns segundos!",
              });
              this.setReprocessingDialog(false);
            } else {
              // eslint-disable-next-line no-undef
              Toast.fire({
                icon: "success",
                title: "Sistema refaturando. Aguarde alguns segundos!",
              });
              this.setReprocessingDialog(false);
            }
          })
          .catch((err) => {
            console.error(err);
            if (this.isPartnerManagement) {
              // eslint-disable-next-line no-undef
              Toast.fire({
                icon: "error",
                title: "Erro ao gerar demonstrativo!",
              });
            } else {
              // eslint-disable-next-line no-undef
              Toast.fire({
                icon: "error",
                title: "Erro ao reprocessar fatura!",
              });
            }
            this.setReprocessingDialog(false);
          });
      }
    },

    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString();
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
